<template>
  <div class="pi-date">
    <div style="text-align:center;margin-top:20px;font-size:20px;">Invoice <a @click="$open(`/invoice-order-view/${doc.id}`, 840)">CYS{{ doc.id }}</a></div>
    <div class="card" style="text-align:center;margin-top:10px;">Delivery Date:
      <el-date-picker v-model="form.date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:150px;"></el-date-picker>
      <el-button @click="setToday" style="margin-left:10px;">Today</el-button>
      <el-button @click="setYesterday">Yesterday</el-button>
      <el-button type="primary" @click="saveDate">Save</el-button>
      <el-button type="danger" @click="clearDate" v-if="form.date">Clear</el-button>
    </div>
    <div class="card">
      <table class="normal-table pi-date-table" style="margin-top:20px;">
        <tr>
          <th>#</th>
          <th>Item</th>
          <th>Invoice Note</th>
          <th>PO Balance</th>
          <th>Vendor</th>
        </tr>
        <tr v-for="(item, index) in productList" :key="item.product_id">
          <td>{{ index + 1 }}</td>
          <td>
            <a @click="$open(`/product/${item.product_id}/stock`)">{{ item.part_no }}</a><br/>
            {{ item.description }}<br/>
            {{ item.brand }}<br/>
            ({{ item.product_id }})
          </td>
          <td style="vertical-align:top;padding:0;">
            <table class="normal-table">
              <tr>
                <th>Price</th>
                <th style="border-right:0;">Qty</th>
              </tr>
              <tr>
                <td style="height:40px;border-bottom:0;text-align:right;font-size:14px;">{{ item.currency }}{{ item.price }}</td>
                <td style="height:40px;border-bottom:0;border-right:0;text-align:left;font-size:14px;">{{ item.qty }} ({{ item.outQty }})<br/>bb:{{ item.qty_bb }} + hk:{{ item.qty_hk }} + sz:{{ item.qty_sz }}</td>
              </tr>
            </table>
          </td>
          <td style="vertical-align:top;padding:0;">
            <table class="normal-table">
              <tr>
                <th>BB</th>
                <th>HK</th>
                <th style="border-right:0;">SZ</th>
              </tr>
              <tr>
                <td style="height:40px;border-bottom:0;text-align:right;font-size:14px;"><template v-if="item.qty_bb>0"><a @click="openDialog(item, 'BB')">{{ item.bb_bal }}</a></template><template v-else>{{ item.bb_bal }}</template></td>
                <td style="height:40px;border-bottom:0;text-align:right;font-size:14px;"><template v-if="item.qty_hk>0"><a @click="openDialog(item, 'HK')">{{ item.hk_bal }}</a></template><template v-else>{{ item.hk_bal }}</template></td>
                <td style="height:40px;border-bottom:0;border-right:0;text-align:right;font-size:14px;"><template v-if="item.qty_sz>0"><a @click="openDialog(item, 'SZ')">{{ item.sz_bal }}</a></template><template v-else>{{ item.sz_bal }}</template></td>
              </tr>
            </table>
          </td>
          <td style="vertical-align:top;padding:0;">
            <table class="normal-table">
              <tr>
                <th>PO No.</th>
                <th>Company</th>
                <th>Type</th>
                <th>Qty</th>
                <th>Remark</th>
                <th style="border-right:0;">del</th>
              </tr>
              <tr v-for="o in item.outList" :key="o.id">
                <td><a @click="$open(`/po-order-view/${o.po_doc_id}`, 840)">PO CYS{{ o.po_doc_id }}</a></td>
                <td :title="o.company_name">{{ o.company_name }}</td>
                <td>{{ o.type }}</td>
                <td style="text-align:right;">{{ o.bb + o.hk + o.sz }}</td>
                <td :title="o.remark">{{ o.remark }}</td>
                <td style="border-right:0;"><el-button type="text" style="color:red;" @click="delStockOut(o.id)">del</el-button></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <el-dialog :title="poDialogTitle" :visible.sync="poDialogVisible" :close-on-click-modal="false">
      <div>
        <a @click="$open(`/product/${poProduct.product_id}/details`)">{{ poProduct.part_no }}</a>&nbsp;&nbsp;{{ poProduct.description }}&nbsp;&nbsp;{{ poProduct.brand }}&nbsp;&nbsp;({{ poProduct.product_id }})
      </div>
      <table class="fixed-table" style="margin-top:10px;">
        <tr>
          <th style="width:80px;">Enter Date</th>
          <th style="width:100px;">PO No.</th>
          <th>Company</th>
          <th style="width:70px;">BB Bal</th>
          <th style="width:70px;">Cost</th>
          <th style="width:80px;">Stock Out</th>
          <th style="width:120px;">Remark</th>
        </tr>
        <tr v-for="(item, index) in poList" :key="item.id">
          <td>{{ item.enter_date }}</td>
          <td><a @click="$open(`/po-order-view/${o.po_doc_id}`, 840)">PO CYS{{ item.doc_id }}</a></td>
          <td :title="item.company_name">{{ item.company_name }}</td>
          <td v-if="poType === 'BB'">{{ item.bb }}</td>
          <td v-else-if="poType === 'HK'">{{ item.hk }}</td>
          <td v-else>{{ item.sz }}</td>
          <td>{{ item.currency }}{{ item.price }}</td>
          <td><el-input v-model.number="poList[index].stock_out_qty"></el-input></td>
          <td><el-input v-model="poList[index].stock_out_remark"></el-input></td>
        </tr>
      </table>
      <no-data :loading="poLoading" :list="poList"></no-data>
      <div style="text-align:center;margin-top:20px;" v-if="poList.length > 0">
        <el-button type="primary" @click="poSave">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import qs from 'qs'
import NoData from '@/components/NoData'
export default {
  components: {
    NoData
  },
  data () {
    return {
      form: {
        date: null
      },
      doc: {},
      productList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'a week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      poDialogVisible: false,
      poProduct: {},
      poType: 'BB',
      poList: [],
      poLoading: false
    }
  },
  computed: {
    poDialogTitle () {
      return `PO-${this.poType} Balance Detail`
    }
  },
  mounted () {
    //this.resetPIStock()
    this.fetchDoc()
    this.fetchProductList()
  },
  methods: {
    resetPIStock () {
      this.$http.post('/dbapi/stock_out_reset', {
        pi_doc_id: this.$route.params.id
      })
    },
    fetchDoc () {
      this.$http.get('/dbapi/pi_doc_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.doc = data.list[0]
          this.form.date = this.doc.delivery_date_e
        }
      })
    },
    fetchProductList () {
      this.$http.get('/dbapi/pi_doc_details?id=' + this.$route.params.id).then(data => {
        let list = data.list
        for (let i = 0; i < list.length; i++) {
          list[i].bb_bal = 0
          list[i].hk_bal = 0
          list[i].sz_bal = 0
          list[i].outQty = 0
          list[i].outList = []
        }
        this.productList = list
        this.fetchPOBalance()
      })
    },
    fetchPOBalance () {
      if (this.productList.length > 0) {
        this.$http.get('/dbapi/po_stock_balance', {
          params: {
            product_ids: this.productList.map(r => r.product_id)
          },
          paramsSerializer: function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        }).then(data => {
          let list = this.productList
          let list2 = data.list
          for (let i = 0; i < list.length; i++) {
            for (let j = 0; j < list2.length; j++) {
              if (list2[j].product_id === list[i].product_id) {
                list[i].bb_bal = parseInt(list2[j].bb)
                list[i].hk_bal = parseInt(list2[j].hk)
                list[i].sz_bal = parseInt(list2[j].sz)
              }
            }
          }
          this.productList = list
          this.fetchStockOut()
        })
      }
    },
    fetchStockOut () {
      if (this.productList.length > 0) {
        this.$http.get('/dbapi/stock_out_list', {
          params: {
            pi_doc_id: this.$route.params.id
          }
        }).then(data => {
          let list = this.productList
          let list2 = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].outQty = 0
            list[i].outList = []
            for (let j = 0; j < list2.length; j++) {
              if (list2[j].product_id === list[i].product_id && list2[j].pi_id === list[i].id) {
                if (list2[j].bb > 0) {
                  list2[j].type = 'BB'
                  list[i].outQty += list2[j].bb
                } else if (list2[j].hk > 0) {
                  list2[j].type = 'HK'
                  list[i].outQty += list2[j].hk
                } else if (list2[j].sz > 0) {
                  list2[j].type = 'SZ'
                  list[i].outQty += list2[j].sz
                }
                list[i].outList.push(list2[j])
              }
            }
          }
          this.productList = list
        })
      }
    },
    openDialog (product, type) {
      this.poProduct = product
      this.poType = type
      this.poDialogVisible = true
      this.fetchPOList()
    },
    fetchPOList () {
      this.poLoading = true
      this.$http.get('/dbapi/po_stock_balance_detail', {
        params: {
          product_id: this.poProduct.product_id,
          stock_type: this.poType 
        }
      }).then(data => {
        this.poLoading = false
        let list = data.list
        for (let i = 0; i < list.length; i++) {
          list[i].stock_out_qty = 0
          list[i].stock_out_remark = ''
        }
        this.poList = list
      })
    },
    poSave () {
      for (let i = 0; i < this.poList.length; i++) {
        let qty = 0
        if (this.poType === 'BB') {
          qty = this.poList[i].bb
        } else if (this.poType === 'HK') {
          qty = this.poList[i].hk
        } else if (this.poType === 'SZ') {
          qty = this.poList[i].sz
        }
        if (this.poList[i].stock_out_qty > qty) {
          this.$alert('出库数量不能大于库存数量', '提示')
          return
        }
      }
      let outs = []
      for (let i = 0; i < this.poList.length; i++) {
        let item = this.poList[i]
        if (item.stock_out_qty > 0) {
          outs.push({
            po_doc_id: item.doc_id,
            po_id: item.id,
            pi_doc_id: this.$route.params.id,
            pi_id: this.poProduct.id,
            product_id: this.poProduct.product_id,
            stock_type: this.poType,
            price: this.poProduct.price,
            bb: this.poType === 'BB' ? item.stock_out_qty : 0,
            hk: this.poType === 'HK' ? item.stock_out_qty : 0,
            sz: this.poType === 'SZ' ? item.stock_out_qty : 0,
            remark: item.stock_out_remark
          })
        }
      }
      if (outs.length === 0) {
        this.poDialogVisible = false
        return
      }
      this.$http.post('/dbapi/stock_out', {
        outs
      }).then(data => {
        this.poDialogVisible = false
        this.fetchPOBalance()
      })
    },
    setToday () {
      this.form.date = moment().format('YYYY-MM-DD')
    },
    setYesterday () {
      let date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24)
      this.form.date = moment(date).format('YYYY-MM-DD')
    },
    saveDate () {
      if (!this.form.date) {
        this.$alert('请选择日期', '提示')
        return
      }
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i].qty !== this.productList[i].outQty) {
          this.$alert('出库数量和Invoice数量不一致', '提示')
          return
        }
      }
      this.$http.post('/dbapi/pi_doc_edit_date', {
        id: this.doc.id,
        date: this.form.date
      }).then(data => {
        this.$close()
      })
    },
    clearDate () {
      this.form.date = null
      this.$http.post('/dbapi/pi_doc_edit_date', {
        id: this.doc.id,
        date: 'null'
      })
    },
    delStockOut (id) {
      this.$confirm('确定要删除这条记录吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/stock_del', { id }).then(data => {
          this.fetchPOBalance()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.pi-date {
  .pi-date-table {
    border-top: 1px solid #999;
    border-left: 1px solid #999;
    th {
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      background: #ddd;
    }
    td {
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      a {
        text-decoration: underline;
        color: #409EFF;
      }
    }
  }
  .el-dialog {
    width: 80%;
    margin-top: 280px!important;
  }
}
</style>


